import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=f634be2a&scoped=true"
import script from "./Shipments.vue?vue&type=script&lang=js"
export * from "./Shipments.vue?vue&type=script&lang=js"
import style0 from "./Shipments.vue?vue&type=style&index=0&id=f634be2a&prod&scoped=true&lang=css"
import style1 from "./Shipments.vue?vue&type=style&index=1&id=f634be2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f634be2a",
  null
  
)

export default component.exports